
export const FIXED_RATE = "FIXED";
export const FLOATING_RATE = "FLOATING";
export const FIXED_RATE_ID = "53669856-4681-11e9-82f6-0242ac120002";
export const FLOATING_RATE_ID = "5813c493-4681-11e9-82f6-0242ac120002";

export default {
  FIXED_RATE,
  FLOATING_RATE,
  FIXED_RATE_ID,
  FLOATING_RATE_ID
};
